import React, { useState } from "react";
import Header from "../../components/Header";
import Hero from "../../components/Hero";
import About from "../../components/About";
import Programs from "../../components/Programs";
import Education from "../../components/Education";
import Journal from "../../components/Journal";
import Library from "../../components/Library";
import Contact from "../../components/Contact";
import Footer from "../../components/Footer";

const HomePage = ({
  language,
  toggleLanguage,
  activeSection,
  scrollToSection,
}) => {
  return (
    <div>
      {/* <Header
        language={language}
        toggleLanguage={toggleLanguage}
        activeSection={activeSection}
        scrollToSection={scrollToSection}
      /> */}
      <Hero language={language} />
      <About language={language} />
      <Programs language={language} />
      <Education language={language} />
      <Journal language={language} />
      <Library language={language} />
      <Contact language={language} />
      <Footer language={language} />
    </div>
  );
};

export default HomePage;
